/**
 * 通过拖拽计算调用回调进行页面视图操作
 * 拖拽计算都在drag.js中实现
 *
 */
// import { MessageBox, Message } from 'element-ui';
// import JQ from 'jquery';
import store from '@/store/index';
import TopicBase from './base/Topic';
import { PAGE_SIZE_CELL, PAGE_CELL_HEIGHT } from '@/subjects/constant';
import { PADDING_TOP, PAGE_LAYOUT_TOP } from '../../../subjects/constant';
import { appendKONGGEToSPAN } from '@/utils/common';
import { Loading } from 'element-ui';
let state = store.state.card;
let answerPanelState = store.state.answerPanel;
const WRAP_CONTENT_CLASS = '.wrapper-content'; // wrapper_content的class
const TOPIC_BOX_CLASS = '.topic-box'; // topic-box的class
const TOPIC_DB_CLASS = '.topic-wrapper'; // topic-bd的class
const WRITE_TOPIC_LINE_CLASS = '.topic-wrapper .writing-cont .writing'; // topic-bd的class
const TH_CLASS = '.topic-th';
const CHOOSE_TITLE_CLS = 'choose-cont-hastitle';
const BORDER_HEIGHT = 1; // 每个编辑器的border高度为1px
const MARGIN_TOP = 10; // 每道大题之间的margintop值为10px
const MARGIN_BOTTOM = 10; // 每个页面底部空白的高度值为10px
let PADDING_TOP_HEIGHT = PADDING_TOP; // 填空题解答题英语作文题的padding高度
const MARGIN_TOP_NUMS = state.pageCell[state.currentPageNum].fillTopiclist.length; // 一页纸张当前有list的长度就代表有多少个margintop的距离
//const TAG_P_HEIGHT = 54; // 一个p元素的固定高度
import { TAG_P_HEIGHT, TAG_110_HEIGHT } from '@/subjects/constant';
const NEXTPAGE_HEAD_INDEX = 0; //下一页头部的下标 默认0
const TH_HEIGHT = 40; //标题高度
const WRITE_LINE_HEIGHT = 42; // 语文作文题一行的高度
const OBJECT_LINE_HEIGHT = 110; // 选择题一行的高度
const MIN_FILL_HEIGHT = 94; // 最小填充高度，如果不足就分页
export default class FillTopic extends TopicBase {
  static DRAG_BUTTON_ID = '#drag_button';
  static DRAG_I_CLASS_ACTIVE = 'drag_i_active';
  static DRAG_I_CLASS = 'el-icon-rank';
  totalPages = 0; // 填空题一共分解了多少页面
  currentPageIndex = 0; // 填空题当前所在的page页数
  currentPage = 0; // 记录初始化当前页码
  useDragButton = true; //默认只在拖拽工具上面操作
  keepUpdateView = false;
  updateViewTimer = 0;
  updateViewHeightCount = 0;
  resolveFillTopicHtmlCount = 0;
  myIndexCount = 0; // 用来判断循环的index 阻止重复循环
  canDragArea = {
    // 计算当前填空题是否存标题高度
    computeTiteHeight: targetItem => {
      return (targetItem.querySelector('.topic-th') || { offsetHeight: 0 }).offsetHeight;
    },
    // 限制鼠标移动的方位
    borderHeight: 2,
    y: 30,
    x: 30,
  };
  innerHTML = '';
  currentTopicStackList = []; // 保存初始化新增的题型数据列表
  loadingInstance = undefined;

  constructor({ width, height, canDrag, myDrag, currentPageIndex }) {
    super(width, height, canDrag);
    this.currentPageIndex = currentPageIndex;
    this.myDrag = myDrag; // 为填空题注入myDrag拖拽实例
    const target = document.querySelectorAll('.topic-box');
    this.init(target);
  }

  init() {
    this.myDrag &&
      this.myDrag.init({
        useDragButton: true,
        pageMaxHeight: this.height,
        canDragArea: this.canDragArea,
        callbacks: {
          deleteCurrentPage: () => this.deleteCurrentPage(),
          findNextPage: overstepDistance => this.findNextPage(overstepDistance),
          dragDown: (target, overstepDistance, currentIndexInPages, hasNextPage) => {
            this.dragDown(target, overstepDistance, currentIndexInPages, hasNextPage);
          },
          mouseDown: index => {
            this.mouseDown(index);
          },
          mouseUp: () => {
            this.mouseUp();
          },
          updateViewHeight: () => {
            this.updateViewHeight();
          },
          copyDragHeightToInitDragHeight: (unMaxDragHeight, currentIndexInPages) =>
            this.copyDragHeightToInitDragHeight(unMaxDragHeight, currentIndexInPages),
          dragUp: (
            target,
            moveDistance,
            hasNextPage,
            currentIndexInPages,
            e,
            targetBeforeMoveHeight,
            dragOption
          ) =>
            this.dragUp(
              target,
              moveDistance,
              hasNextPage,
              currentIndexInPages,
              e,
              targetBeforeMoveHeight,
              dragOption
            ),
          updateCurrentStackInitDragHeight: currentIndexInPages =>
            this.updateCurrentStackInitDragHeight(currentIndexInPages),
        },
      }); //初始化 鼠标按下之后的一系列操作（按下后移动）
    this.myDrag && this.myDrag.initVuexStore(store);
    const currentTopicStackList = state.pageCell[state.pageCell.length - 1].fillTopiclist;
    const currentTopicStack = currentTopicStackList[currentTopicStackList.length - 1];
    this.innerHTML = currentTopicStack && currentTopicStack.innerHTML; // 用来保存新增的innerHtml
    this.currentTopicStackList = currentTopicStackList;
    this.currentPage = state.pageCell.length - 1;
  }

  /**
   * 判断鼠标是否在拖拽区域
   * @param {Event} e 事件event
   * @param {Element} element 鼠标移入移出当前元素
   * @param {object} canDragArea 可拖拽区域 (判断鼠标移入移出变色拖拽器)
   * @return {boolean}
   */
  inDragArea(e, element, canDragArea) {
    const { borderHeight, x, y, computeTiteHeight } = canDragArea;
    const titleHeight = computeTiteHeight(element);
    const inDragArea =
      e.offsetX > element.offsetWidth - borderHeight * 2 - x &&
      e.offsetY > element.offsetHeight - borderHeight * 2 - y - titleHeight; // 判断当前鼠标在拖拽器上面
    return inDragArea;
  }

  /**
   * 寻找单个元素
   * @param {string} relativeTarget 相对目标 全局document
   * @param {string} classString 元素class
   */
  findOneElementByClass(relativeTarget, classString) {
    relativeTarget = relativeTarget || document;
    return relativeTarget.parentNode.querySelector(classString);
  }
  /**
   * 寻找单个元素
   * @param {string} relativeTarget 相对目标 全局document
   * @param {string} tagName 标签名
   */
  findOneElementByTagName(relativeTarget, tagName) {
    relativeTarget = relativeTarget || document;
    return relativeTarget.parentNode.querySelector(tagName);
  }

  computedCurrentMaxHeight() {}

  /**
   * 删除当前页面
   */
  deleteCurrentPage() {
    // alert('删除当前页面');
  }

  copyDragHeightToInitDragHeight(unMaxDragHeight, currentIndexInPages) {
    try {
      state.pageCell[state.currentPageNum].fillTopiclist[
        this.findCurrentIndexInPages(currentIndexInPages)
      ] &&
        (state.pageCell[state.currentPageNum].fillTopiclist[
          this.findCurrentIndexInPages(currentIndexInPages)
        ].initDragHeight = unMaxDragHeight);
    } catch (e) {
      console.error('拖拽没有到达最大高度计算高度报错', e.message);
    }
  }

  /**
   * 及时更新拖拽元素的数据height（initDragHeight）
   * @param {number} currentIndexInPages
   */
  updateCurrentStackInitDragHeight(currentIndexInPages) {
    const currentPageStack =
      state.pageCell[state.currentPageNum] &&
      state.pageCell[state.currentPageNum].fillTopiclist[
        this.findCurrentIndexInPages(currentIndexInPages)
      ];
    // alert(this.findCurrentIndexInPages(currentIndexInPages));
    const currentPageStackDom = this.findCurrentPageStackDom(
      this.findCurrentIndexInPages(currentIndexInPages)
    );

    // const thDom = currentPageStackDom.querySelector(TH_CLASS);
    if (currentPageStackDom) {
      if (currentPageStack.type != 3) {
        currentPageStack && (currentPageStack.initDragHeight = currentPageStackDom.offsetHeight);
      } else {
        currentPageStack && (currentPageStack.initDragHeight = currentPageStackDom.offsetHeight);
      }
    }
  }

  /**
   * 向上拖拽
   * （一）当前纸张是最后一页，向上拖拽时候 减少元素高度，判断是否拖拽题型是否有内容
     > 有内容，则减少到内容的高度（最小高度），拖拽事件取消
     > 无内容，则拖拽减少至高度为0时 删除元素（这种情况，分两种 1 当前纸张页面只有这种空白的元素，可以删除元素，2.当前纸张最上边是空白题型，下面有包含内容的题型）

  （二）当前纸张不是最后一页，这种情况比较复杂，涉及到向下联动 
     向下拖拽如果内容是满的则不触发dom事件，如果向下拖拽过后，当前纸张没有达到当前最高高度的时候，递归向下寻找下一页纸张的头部元素向上拼接上一页的底部元素
    这里几种情况 1. 当下一页的头部元素小于向上拖拽的高度时候，删除当前元素，并且将上一页的IsH是否跨栏设置false 高度全部增加到上一页底部过去
       
   * @param {*} moveDistance 向上拖拽的距离
   * @param {*} hasNextPage
   * @param {Element} target
   * @param {Event} e
   * @param {*} currentIndexInPages
   */
  dragUp(
    target,
    moveDistance,
    hasNextPage,
    currentIndexInPages,
    e,
    targetBeforeMoveHeight,
    dragOption
  ) {
    // 如果是拖拽了很大距离 然后到达了最小高度 要区别对待
    const isDragFootTopicStack =
      this.findCurrentIndexInPages(currentIndexInPages) >=
      this.findCurrentPageFootIndex(state.currentPageNum);
    const CURRENTPAGE_FOOT_INDEX = this.findCurrentPageFootIndex(state.currentPageNum);
    const currentPageFootStack = this.findCurrentPageFootStack(
      state.currentPageNum,
      CURRENTPAGE_FOOT_INDEX
    );
    const isLastPageCellNum = state.currentPageNum === state.pageCell.length - 1;
    let absMoveDistance = Math.abs(moveDistance);
    if (absMoveDistance <= 0 && dragOption.cacheClientY == 0) {
      return;
    }
    const iframe = target.getElementsByTagName('iframe')[0];
    const elements = iframe.contentWindow.document.body.childNodes;
    const currentStack =
      state.pageCell[state.currentPageNum].fillTopiclist[state.currentIndexInPage];
    if (target.offsetHeight <= MARGIN_BOTTOM + TAG_P_HEIGHT + MARGIN_BOTTOM + PADDING_TOP_HEIGHT) {
      if (target.className.indexOf(CHOOSE_TITLE_CLS) != -1) {
        // 这里对选做题做特殊处理 是因为选做题里面的题号不是html insert生成的 所以这边需要做下判断
        return;
      }
      // if (currentStack.hasTitle) {
      // 这里的判断错误 所以注释掉 不能return 这里是否has标题只是用来判断能不能拖拽删除 不可以return阻止后续操作
      //   return;
      // }
      if (
        elements &&
        elements.length <= 1 &&
        elements[0].innerText.length <= 1 &&
        !currentStack.hasTitle
      ) {
        const delStack = state.pageCell[state.currentPageNum].fillTopiclist.splice(
          state.currentIndexInPage,
          1
        );
        absMoveDistance = absMoveDistance + (delStack[0].initDragHeight || 0);
        state.pageCell[state.currentPageNum - 1].fillTopiclist[
          state.pageCell[state.currentPageNum - 1].fillTopiclist.length - 1
        ].isHurdle = false;
      }
    }
    // if (absMoveDistance >= targetBeforeMoveHeigwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwht - (TAG_P_HEIGHT + MARGIN_BOTTOM)) {
    // 当向上拖拽的距离大于元素的高度-一个p的高度则删除当前元素stack题型
    // !state.pageCell[state.currentPageNum - 1].fillTopiclist[
    //   state.pageCell[state.currentPageNum - 1].fillTopiclist.length - 1
    // ].hasTitle && state.pageCell[state.currentPageNum].fillTopiclist.shift();
    // state.pageCell[state.currentPageNum - 1].fillTopiclist[
    //   state.pageCell[state.currentPageNum - 1].fillTopiclist.length - 1
    // ].isHurdle = false;
    // }
    clearInterval(this.updateViewTimer);
    this.myIndexCount = state.currentPageNum;
    this.updateViewTimer = setTimeout(() => {
      // this.updateViewHeight();
      this.updateViewHeightByDirectionUp(absMoveDistance, false, isDragFootTopicStack);
      clearTimeout(this.updateViewTimer);
    }, 200); // 这里定时器有一个很重要 需要注意的问题 就是上面拖拽删除了题型元素之后 页面会重新布局渲染 这时候编辑器也会重新加载
    // 这样的话需要等编辑器重新加载完成之后在执行updateViewHeightByDirectionUp操作 测试这里200ms延时之后 编辑器重新加载可在200ms内完成
    const timer = setTimeout(() => {
      // this.hideLoading();
      // 防止loading删除不掉
      clearTimeout(timer);
    }, 800);
  }

  /**
   * 鼠标拖拽超过部分去除 填满之前的高度
   * @param {Element} target 当前纸张拖拽的最后一个元素
   * @param {*} overstepDistance
   * @param {*} currentIndexInPages
   * @param {*} hasNextPage 切割判断是否已经有下一页
   */
  dragDown(target, overstepDistance, currentIndexInPages, hasNextPage) {
    if (overstepDistance <= 1) {
      return;
    }
    // 这里递归currentIndexInPages 需要改动
    const isDragFootTopicStack =
      this.findCurrentIndexInPages(currentIndexInPages) >=
      this.findCurrentPageFootIndex(state.currentPageNum);
    // 跨栏分解题型计算p的高度
    let count = 0;
    clearInterval(this.updateViewTimer);
    this.updateViewTimer = setTimeout(() => {
      // this.updateViewHeight();
      this.updateViewHeight(overstepDistance, isDragFootTopicStack);
      clearTimeout(this.updateViewTimer);
    }, 20);
    const timer = setTimeout(() => {
      // this.hideLoading();
      // 防止loading删除不掉
      clearTimeout(timer);
    }, 1000);
    // 这里用定时器取消计时器 为了dom更新结束
  }

  mouseDown(index) {
    // index = this.findCurrentIndexInPages(index);
    // let wrapperContentElements = document.querySelectorAll(WRAP_CONTENT_CLASS)[
    //   state.currentPageNum
    // ];
    // let array = wrapperContentElements.querySelectorAll(TOPIC_DB_CLASS);
    // Array.from(array).forEach((element, _index) => {
    //   if (index != _index) {
    //     element.style.pointerEvents = 'none';
    //   }
    // });
    document.querySelector('.card-make-content .card-make-box').style.pointerEvents = 'none';
    // const timer = setTimeout(() => {
    //   this.mouseUp();
    //   clearTimeout(timer);
    // }, 1000);
  }

  mouseUp() {
    // let wrapperContentElements = document.querySelectorAll(WRAP_CONTENT_CLASS);
    // Array.from(wrapperContentElements).forEach((wrapperContentElement, index) => {
    //   let array = wrapperContentElement.querySelectorAll(TOPIC_DB_CLASS);
    //   Array.from(array).forEach((element, _index) => {
    //     element.style.pointerEvents = 'auto';
    //     console.log('哈哈33哈', element);
    //   });
    // });
    document.querySelector('.card-make-content .card-make-box').style.pointerEvents = 'auto';
  }

  /**
   * 用来计算递归的超出高度 通过已经生成的dom 这样计算精准一些
   * @param {*} list
   * @param {*} wrapperContentElements
   */
  getOverStepDistanceByDom(list, wrapperContentElements, page) {
    let overstepDistance = 0;
    const topicEls = Array.from(wrapperContentElements.querySelectorAll(TOPIC_DB_CLASS));
    topicEls.length &&
      list.forEach((item, index) => {
        overstepDistance += (topicEls[index] || { offsetHeight: 0 }).offsetHeight;
      });
    return overstepDistance - page.contentHeight ? overstepDistance - page.contentHeight : 0;
  }

  /**
   * 更新拖拽整个答题卡的题型超出高度计算
   * @param {Boolean} deleteEmptyPageisDragFootTopicStack 是否是拖拽的当前最后一个题型
   * @param {String} action 就是触发的方式 drag 和 blur两种
   */
  updateViewHeight(overstepDistance, isDragFootTopicStack, isSelfCall, action) {
    // 作文题向下拖拽的时候空白区域要做判断 删除空白区域而不是里面的方格
    this.updateViewHeightCount++; // 用来停止递归的计数器
    this.page.deleteEmptyPage(); //每次更新高度查看是否有空白页面有则删除
    // 理想情况应该是等元素高度增加之后开始遍历，updateCurrentStackInitDragHeight方法执行之后
    this.keepUpdateView = false;
    let resolveTopic = {};
    let deleteIdx = 0;
    let overHeightAfterDelete = 0;
    let canSetCurrentPageNum = true;
    state.pageCell.forEach((page, index) => {
      let wrapperContentElements = document.querySelectorAll(WRAP_CONTENT_CLASS)[index];
      // if (index >= state.currentPageNum) {
      if (index >= state.currentPageNum - 1) {
        // if (index >= state.currentPageNum) {
        // 这里index+1 是因为 拖拽有可能鼠标会移动到下一页的page上面 会设置currentPageNum+1
        let currentPageNum = state.currentPageNum;
        currentPageNum++;
        canSetCurrentPageNum && store.dispatch('card/setCurrentPageNum', currentPageNum);
        canSetCurrentPageNum = false;
        // page.totalHeight = 0;
        page.totalHeight = 0;
        // 鼠标指在当前的纸张下标
        overstepDistance = isSelfCall
          ? this.getOverStepDistanceByDom(
              JSON.parse(JSON.stringify(page.fillTopiclist)),
              wrapperContentElements,
              page
            )
          : overstepDistance;
        JSON.parse(JSON.stringify(page.fillTopiclist))
          .reverse()
          .forEach((topic, _index) => {
            const topicEls = Array.from(
              wrapperContentElements.querySelectorAll(TOPIC_DB_CLASS)
            ).reverse();
            const topicEl = topicEls[_index];
            // console.log('数组反转', `当前第${index + 1}页`, topicEls, `下标是${_index}`, topicEl);
            // page.totalHeight += topic.initDragHeight + TH_HEIGHT;
            let myOffsetHeight = (topicEl || { offsetHeight: 0 }).offsetHeight;
            // 这里存在一种情况 编辑框内部回车超过外框的高度 需要自动撑开 topicEls获取的是最外层的div元素 获取的offsetheight高度还是外框的高度
            // （最好是循环编辑框iframe内部body下的元素集合的总高度 最为精准）
            // myOffsetHeight <= topic.initDragHeight ? topic.initDragHeight : myOffsetHeight;
            page.totalHeight += myOffsetHeight; //整个题型的高度需要加上头部的高度 这里不需要加上头部topicEl高度 因为topicEl本身就带上了topicEl的高度
            if (overstepDistance > page.totalHeight - TH_HEIGHT) {
              // 这里减去题号高度 是因为向下拖拽的话只要超过题目本身内容的高度就可以算是删除当前题型，所以delIndex下标+1
              deleteIdx = _index;
              overHeightAfterDelete = overstepDistance - page.totalHeight;
            }
            // const topicBoxElements = wrapperContentElements.querySelectorAll(TOPIC_BOX_CLASS);
          }); // 数组反转是为了计算删除时的下标
        let lastStackInPage = page.fillTopiclist[page.fillTopiclist.length - 1]; // 当前纸张的最后一栈
        if (page.totalHeight > page.contentHeight) {
          this.showLoading();
          this.keepUpdateView = true;
          let currentPageDistance = page.totalHeight - page.contentHeight;
          let delLastStack = undefined;
          let nextPage = state.pageCell[index + 1];
          // if (isDragFootTopicStack && lastStackInPage.isSub) { // 如果是子题型占满一页空白 则拖拽不做任何处理
          //   lastStackInPage.initDragHeight -= currentPageDistance + MARGIN_BOTTOM;
          //   this.keepUpdateView = false;
          //   return;
          // }
          if (
            currentPageDistance > lastStackInPage.initDragHeight ||
            (lastStackInPage.type == 5 &&
              currentPageDistance >
                lastStackInPage.initDragHeight - TH_HEIGHT - WRITE_LINE_HEIGHT) ||
            (lastStackInPage.type == 2 &&
              currentPageDistance > lastStackInPage.initDragHeight - TH_HEIGHT - OBJECT_LINE_HEIGHT)
          ) {
            // type 5是语文作文题
            // 这里还存在一个bug 连续拖拽两次全部题型 消失！
            // 超过高度大于最后的元素 分两种情况，一种是只大于最后一个元素 还有一种是大于最后多个元素
            if (lastStackInPage.type == 5) {
              // 这里语文作文题有bug 所以拖拽没有超过高度也属于超过高度的状态
              // deleteIdx = 0;
            }
            delLastStack = page.fillTopiclist.splice(page.fillTopiclist.length - deleteIdx - 1); // 拖拽超过的元素个数
            // 这种情况下不存在两个跨栏的题型
            if (nextPage) {
              // 如果有下一页的话 这里有bug 会把下面的题型html弄没
              const delLastHurdleStack = delLastStack[delLastStack.length - 1];
              // const [delLastHurdleStack] = delLastStack.filter((stack, index) => {
              //   return !stack.isHurdle;
              // }); // 筛选出跨栏的题型 然后拼接下一页头部题型
              let nextHeadStack = nextPage.fillTopiclist[0];
              //
              if (lastStackInPage.isHurdle) {
                // 超过跨栏剩余的全部
                nextHeadStack &&
                  (nextHeadStack = {
                    ...(delLastHurdleStack || {}),
                    innerHTML: (delLastHurdleStack || {}).innerHTML + nextHeadStack.innerHTML,
                    initDragHeight:
                      (delLastHurdleStack || {}).initDragHeight + nextHeadStack.initDragHeight,
                    isHurdle: nextHeadStack.isHurdle,
                    hasTitle: (delLastHurdleStack || {}).hasTitle,
                  }); // 这里有个坑，如果一个对象数组，你改变其中一个对象的属性，原数组会改变，对象指针的引用问题，如果你重新赋值一个对象，则原数组不会改变
                nextPage.fillTopiclist[0] = nextHeadStack;
                delLastStack.splice(delLastStack.length - 1); // 正常情况下最后一题型属于跨栏，合并之后应该删除
                nextPage.fillTopiclist = delLastStack.concat(nextPage.fillTopiclist);
              } else {
                // 超过非跨栏剩余的全部 不需要合并也不需要删除
                nextPage.fillTopiclist = delLastStack.concat(nextPage.fillTopiclist);
              }

              if (overHeightAfterDelete > 10) {
                // 如果去除删除的题型还有超出的距离分解题型到下一页
                this.cutLastStackInPage(page, index, overHeightAfterDelete);
                overHeightAfterDelete = 0;
              } else {
                // page.fillTopiclist[page.fillTopiclist.length - 1] &&
                //   (page.fillTopiclist[page.fillTopiclist.length - 1].initDragHeight -= TH_HEIGHT);
                // 不知道这里为什么要减去题号高度
                // 减去题号高度 在使用下划线功能超出编辑器内容时 编辑器自动升高的时候会出现内容隐藏 去除减去题号高度这一操作就没问题
                page.fillTopiclist[page.fillTopiclist.length - 1] &&
                  (page.fillTopiclist[page.fillTopiclist.length - 1].isHurdle = false); // console.log(
                //   page.fillTopiclist[page.fillTopiclist.length - 1],
                //   'page.fillTopiclist[page.fillTopiclist.length - 1]'
                // );
                // page.fillTopiclist[page.fillTopiclist.length - 1].isHurdle = false;
                // 这个代表拖拽超出题型 没有多余的高度这时候应该表示上下题型分解完全 都没有跨栏 ishurdle为false
              }
            } else {
              // debugger;
              this.page.createNextPage(state.pageCell);
              let nextPage = state.pageCell[index + 1];
              nextPage.fillTopiclist = delLastStack.concat(nextPage.fillTopiclist);
              if (overHeightAfterDelete > 0) {
                this.cutLastStackInPage(page, index, overHeightAfterDelete);
                overHeightAfterDelete = 0;
              } else {
                nextPage.fillTopiclist[0].isHurdle = false;
                page.fillTopiclist[page.fillTopiclist.length - 1] &&
                  (page.fillTopiclist[page.fillTopiclist.length - 1].isHurdle = false);
              }
            }
          } else if (
            !isDragFootTopicStack &&
            currentPageDistance > lastStackInPage.initDragHeight - (TAG_P_HEIGHT + MARGIN_BOTTOM) &&
            currentPageDistance < lastStackInPage.initDragHeight
          ) {
            // 这里有一种特殊情况 isDragFootTopicStack 就是当拖拽的是当前自己的元素的话 只会拖拽是当前页最后元素的高度增加而不是向下减少这种情况不应该进入该条件语句
            if (lastStackInPage.type == 5) {
              // 这里语文作文题有bug 所以拖拽没有超过高度也属于超过高度的状态
              // return;
            }
            // 没有超过最大高度 但是最后题型减去移动的题型不足以最低高度 同样也是删除当前最后的题型
            delLastStack = page.fillTopiclist.pop(); // 拖拽超过的元素个数
            if (nextPage) {
              page.fillTopiclist[page.fillTopiclist.length - 1] &&
                (page.fillTopiclist[page.fillTopiclist.length - 1].isHurdle = false);
              let nextHeadStack = nextPage.fillTopiclist[0];
              if (delLastStack.isHurdle) {
                // if (nextHeadStack.isHurdle) {
                // 这里不应该看nextstack 应该看当前页底部是不是跨栏也就是delLastStack被删除的
                // 如果下一页头部stack题型是拖拽分解状态的isHurdle true 则应该拼接
                nextHeadStack &&
                  delLastStack &&
                  (nextHeadStack = {
                    ...delLastStack,
                    innerHTML: delLastStack.innerHTML + nextHeadStack.innerHTML,
                    initDragHeight: delLastStack.initDragHeight + nextHeadStack.initDragHeight + 10,
                    hasTitle: delLastStack.hasTitle,
                    isHurdle: false,
                  }); // 这里有个坑，如果一个对象数组，你改变其中一个对象的属性，原数组会改变，对象指针的引用问题，如果你重新赋值一个对象，则原数组不会改变
                nextPage.fillTopiclist[0] = nextHeadStack;
              } else {
                // 如果下一页头部stack题型分解完毕 则数组头部添加删除的stack题型
                nextPage.fillTopiclist = (Array.isArray(delLastStack)
                  ? delLastStack
                  : [delLastStack]
                ).concat(nextPage.fillTopiclist);
              }
              // page.fillTopiclist[page.fillTopiclist.length - 1].initDragHeight +=
              //   delLastStack.initDragHeight - currentPageDistance; // 把删除之后的最后题型高度加上删除题型的高度
            } else {
              this.page.createNextPage(state.pageCell);
              let nextPage = state.pageCell[index + 1];
              nextPage.fillTopiclist = [delLastStack].concat(nextPage.fillTopiclist);
              nextPage.fillTopiclist[0] = {
                ...nextPage.fillTopiclist[0],
                hasTitle: delLastStack.hasTitle,
              };
              page.fillTopiclist[page.fillTopiclist.length - 1].isHurdle = false;
              page.fillTopiclist[page.fillTopiclist.length - 1].initDragHeight +=
                delLastStack.initDragHeight - currentPageDistance; // 把删除之后的最后题型高度加上删除题型的高度 填充上去 看起来比较好些
            }
          } else {
            // 超过高度小于最后的元素
            if (lastStackInPage && !isDragFootTopicStack) {
              // 当前纸张的最后一栈不为空
              // if (lastStackInPage && !isDragFootTopicStack) {
              // 如果是填空题就分解题型
              // 代表拖拽的元素就是当前最后一个题型，拖拽的空白追加到下一题型元素
              if (page.fillTopiclist[page.fillTopiclist.length - 1].type == 5) {
                currentPageDistance =
                  WRITE_LINE_HEIGHT * parseInt(currentPageDistance / WRITE_LINE_HEIGHT); // 跨栏情况下如果是解答题的话 我们只需要减去一个底部的高度10px就可以 如果是其他题型目前有想到的是 作文题，英语作文题
              }
              resolveTopic =
                this.resolveFillTopicHtml(
                  action,
                  index,
                  lastStackInPage.type,
                  lastStackInPage,
                  currentPageDistance
                ) || resolveTopic;
              resolveTopic =
                this.resolveWriteTopicHtml(
                  lastStackInPage,
                  lastStackInPage.innerHTML,
                  currentPageDistance,
                  undefined,
                  index
                ) || resolveTopic;
              resolveTopic =
                this.resolveObjectTopicHtml(
                  // 因为选择题 拖拽一小部分就会导致110px整体移动，所以下一页的stack height需要110的整数倍数加上
                  lastStackInPage.type,
                  lastStackInPage,
                  currentPageDistance,
                  undefined,
                  index
                ) || resolveTopic;
            }
            if (resolveTopic.topHtml === null) {
              // 当前题型已经分解完毕，没有topHtml了
              // this.deleteLastStackInPage(page);
              const delStack = page.fillTopiclist.pop();

              nextPage &&
                nextPage.fillTopiclist[0] &&
                (nextPage.fillTopiclist[0] = {
                  ...delStack,
                  initDragHeight: nextPage.fillTopiclist[0].initDragHeight,
                  innerHTML: nextPage.fillTopiclist[0].innerHTML || '',
                });
              // 代表拖拽的题型全部分解到下一页了
            } else {
              lastStackInPage && (lastStackInPage.initDragHeight -= currentPageDistance);
              // lastStackInPage &&
              //   (lastStackInPage.initDragHeight -= isSelfCall
              //     ? overstepDistance
              //     : currentPageDistance);
              //对作文题留白太多做特殊处理

              if (
                resolveTopic.topHtml &&
                resolveTopic.topHtml.indexOf('script type="text/javascript') != -1
              ) {
                // 这里属于异常情况 编辑器初始化出现问题导致分解题型出问题
              } else {
                if (resolveTopic.topHtml != '') {
                  !isDragFootTopicStack &&
                    lastStackInPage &&
                    (lastStackInPage.innerHTML = resolveTopic.topHtml || '');
                } else {
                  // 上面分解的题型内容为空 直接删除
                  page.fillTopiclist.pop();
                  if (nextPage) {
                    nextPage.fillTopiclist[0] && (nextPage.fillTopiclist[0].isHurdle = false);
                    nextPage.fillTopiclist[0] && (nextPage.fillTopiclist[0].isSub = undefined); // 题型合并之后 是否为子节点 置为false/undefined
                    nextPage.fillTopiclist[0] &&
                      lastStackInPage.isHurdle &&
                      (nextPage.fillTopiclist[0].hasTitle = lastStackInPage.hasTitle);
                  }
                }
              }
            }
            // let type = lastStackInPage.type;
            if (nextPage) {
              // 如果有下一页
              if (
                lastStackInPage.isHurdle &&
                (lastStackInPage.no ==
                  (nextPage.fillTopiclist[0] && nextPage.fillTopiclist[0].no) ||
                  lastStackInPage.type == 6 ||
                  lastStackInPage.type == 1) &&
                lastStackInPage.type ==
                  (nextPage.fillTopiclist[0] && nextPage.fillTopiclist[0].type)
              ) {
                // 这里多判断一次 如果当前页底部type类型和no题号一至才算分解跨栏题型
                // 如果已经跨栏的话 否则新增
                // 将超过的多余高度插入下一页头部stack 然后循环 下一页
                nextPage.fillTopiclist[0] &&
                  (nextPage.fillTopiclist[0].innerHTML =
                    (resolveTopic.bottomHtml || '') + nextPage.fillTopiclist[0].innerHTML || '');
                nextPage.fillTopiclist[0] &&
                  (nextPage.fillTopiclist[0].initDragHeight +=
                    (resolveTopic.resolveHeight || currentPageDistance) + 20);
                // 20是因为一个回车键可能大于一个p的高度54px
              } else {
                this.insertNextPageHeadStack(
                  nextPage,
                  (resolveTopic.resolveHeight || currentPageDistance) + 20,
                  lastStackInPage.type,
                  resolveTopic.bottomHtml || '',
                  lastStackInPage,
                  resolveTopic
                );
                lastStackInPage && (lastStackInPage.isHurdle = true);
              }
            } else {
              if (!resolveTopic.bottomHtml && lastStackInPage.type == 5) {
              } else {
                // 只有语文作文的情况下 html为空字符串的时候 不需要创建下一页
                this.page.createNextPage(state.pageCell);
                // lastStackInPage.isHurdle = true;
                if (resolveTopic.topHtml == '') {
                  // tophtml为空的话 代表分解了一个整个题型 上面的html为空
                  page.fillTopiclist[page.fillTopiclist.length - 1] &&
                    (page.fillTopiclist[page.fillTopiclist.length - 1].isHurdle = false);
                } else {
                  page.fillTopiclist[page.fillTopiclist.length - 1] &&
                    (page.fillTopiclist[page.fillTopiclist.length - 1].isHurdle = true);
                }
                this.insertNextPageHeadStack(
                  state.pageCell[index + 1],
                  (resolveTopic.resolveHeight || currentPageDistance) + 20,
                  // currentPageDistance + 20, // 多加20是为了编辑器回车超过高度的时候 去除滚动条
                  lastStackInPage.type,
                  resolveTopic.bottomHtml || '',
                  lastStackInPage,
                  resolveTopic
                );
              }
            }
            // state.pageCell[state.pageCell.length - 1].fillTopiclist[0] = {
            //   initDragHeight: 'overstepDistance',
            //   innerHTML: '<p>下一页头部插入高度overstepDistance</p>',
            //   isHurdle: true,
            // };
          }
          isDragFootTopicStack = false;
          // setTimeout(() => {
          //   this.updateViewHeight(overstepDistance, isDragFootTopicStack);
          // }, 20);
        }
        page.fillTopiclist.forEach((topic, _topInx) => {
          topic && this.doWriteEnTopicWhiteSpace(page.fillTopiclist[_topInx], index, _topInx);
          // 为了遍历之后能将解答题的高度更新成真实的dom高度
        });
        this.doWriteTopicWhiteSpace(
          page.fillTopiclist[page.fillTopiclist.length - 1],
          index,
          page.fillTopiclist.length - 1
        );
      } else {
        console.log('向下拖拽时布局保持不变 从', index, '下标开始');
      }
    });
    if (this.keepUpdateView && this.updateViewHeightCount <= state.pageCell.length) {
      const timer = setTimeout(() => {
        this.updateViewHeight(overstepDistance, isDragFootTopicStack, true, action);
        clearTimeout(timer);
      }, 300);
    } else {
      this.updateViewHeightCount = 0;
      this.hideLoading();
      return;
    }
  }

  /**
   * 更新拖拽整个答题卡的题型未满的高度
   * @param {number} moveDistance
   */
  updateViewHeightByDirectionUp(moveDistance, isSelfCall, isDragFootTopicStack) {
    this.updateViewHeightCount++;
    this.page.deleteEmptyPage(); //每次更新高度查看是否有空白页面有则删除
    this.keepUpdateView = false;
    // console.log('向上拖拽触发向上拖拽的距离', moveDistance);
    let resolveTopic = {};
    let deleteIdx = 0;
    let overHeightAfterDelete = 0;
    let canSetCurrentPageNum = true;
    state.pageCell.forEach((page, index) => {
      if (index >= state.currentPageNum && canSetCurrentPageNum) {
        // if (index >= state.currentPageNum - 1) {
        let currentPageNum = state.currentPageNum;
        currentPageNum++;
        canSetCurrentPageNum && store.dispatch('card/setCurrentPageNum', currentPageNum);
        canSetCurrentPageNum = false;
        page.totalHeight = 0;
        const wrapperContentElements = document.querySelectorAll(WRAP_CONTENT_CLASS)[index]; // 鼠标旨在当前的纸张下标
        JSON.parse(JSON.stringify(page.fillTopiclist)).forEach((topic, _index) => {
          const topicEl = wrapperContentElements.querySelectorAll(TOPIC_DB_CLASS)[_index];
          // 这里作文题的offsetHeight需要减去10px因为和浏览器审查元素的高度相差10
          page.totalHeight += (topicEl || { offsetHeight: 0 }).offsetHeight;
          // console.log(
          //   wrapperContentElements,
          //   JSON.parse(JSON.stringify(page.fillTopiclist)).reverse(),
          //   `当前${index + 1}页${_index}元素是${topicEl}高度是${topicEl.offsetHeight}页面总高度${
          //     page.totalHeight
          //   }`
          // );
          // page.totalHeight += topic.initDragHeight + TH_HEIGHT;
          // if (moveDistance > page.totalHeight) {
          //   deleteIdx = _index;
          //   overHeightAfterDelete = moveDistance - page.totalHeight;
          // }
          // const topicBoxElements = wrapperContentElements.querySelectorAll(TOPIC_BOX_CLASS);
        }); // 数组反转是为了计算删除时的下标
        let currentPageDistance = page.contentHeight - page.totalHeight;
        if (
          page.fillTopiclist[page.fillTopiclist.length - 1] &&
          !page.fillTopiclist[page.fillTopiclist.length - 1].isHurdle &&
          currentPageDistance < TAG_P_HEIGHT
        ) {
          // 如果每一页的底部不是跨栏的情况下斌给并且currentPageDistance小于一个p
          return;
        }
        let currentFootStackInPage = page.fillTopiclist[page.fillTopiclist.length - 1]; // 当前纸张的最后一栈
        if (
          (currentFootStackInPage && currentFootStackInPage.isHurdle && currentPageDistance > 1) ||
          (currentPageDistance >= TH_HEIGHT + MARGIN_BOTTOM + TAG_P_HEIGHT &&
            index != state.pageCell.length - 1)
        ) {
          this.showLoading();
          // 如果上下页不跨栏的情况下 是要达到最小高度才能进入分解题型 如果上下页跨栏的情况下 则不受限制
          // if (page.contentHeight - page.totalHeight >= TH_HEIGHT + TAG_P_HEIGHT) {
          this.keepUpdateView = true;
          // console.log(`当前${index + 1}页没有填满的高度,高度是${currentPageDistance}`);
          // if (page.totalHeight < page.contentHeight) {
          let nextPage = state.pageCell[index + 1];
          let nextHeadStackInPage = nextPage && state.pageCell[index + 1].fillTopiclist[0];
          // 上面拖拽距离减少，它的下一页头部stack题型高度减少，然后上一页底部题型stack高度增加拖拽的高度；然后递归
          // console.log(
          //   `当前第${index + 1}页的底部题型${currentFootStackInPage}`,
          //   currentFootStackInPage
          // );
          if (currentFootStackInPage && currentFootStackInPage.isHurdle) {
            //  当前页是跨栏
            if (currentFootStackInPage.type == 5) {
              // 语文作文
              let wrapperContentElements = document.querySelectorAll(WRAP_CONTENT_CLASS)[index];
              let writeLineNums = wrapperContentElements.querySelectorAll(WRITE_TOPIC_LINE_CLASS)
                .length;
              const spaceWriteHeight =
                currentFootStackInPage.initDragHeight -
                writeLineNums * WRITE_LINE_HEIGHT -
                MARGIN_BOTTOM;
              if (spaceWriteHeight > MARGIN_BOTTOM) {
                currentPageDistance = currentPageDistance + spaceWriteHeight;
              }
            }
            if (page.fillTopiclist[page.fillTopiclist.length - 1].type == 5) {
              currentPageDistance =
                WRITE_LINE_HEIGHT * parseInt(currentPageDistance / WRITE_LINE_HEIGHT); // 跨栏情况下如果是解答题的话 我们只需要减去一个底部的高度10px就可以 如果是其他题型目前有想到的是 作文题，英语作文题
            }
            resolveTopic =
              // isSelfCall && //这里为什么是自身调用自身的时候才进行题型分解呢？ 需要思考下
              // 这里涉及到作文题留白太多 导致高度计算失准 留白太多使得本身高度initDragHeight大于真实的dom高度 需要减去
              //  1 表示填空题，2 表示客观题，3 表示解答题，4表示英文作文，5表示语文作文，6表示选做题
              nextHeadStackInPage &&
              this.resolveTopicFactory(
                index,
                resolveTopic,
                nextHeadStackInPage,
                currentPageDistance, // 跨栏情况下如果是解答题的话 我们只需要减去一个底部的高度10px就可以 如果是其他题型目前有想到的是 作文题，英语作文题
                // currentPageDistance - (nextHeadStackInPage.type == 3 ? MARGIN_BOTTOM : TH_HEIGHT), // 跨栏情况下如果是解答题的话 我们只需要减去一个底部的高度10px就可以 如果是其他题型目前有想到的是 作文题，英语作文题
                true
              );
            // 这里由于延迟的原因导致initDragHeight和真实dom高度不一致（偏小） 所以需要获取当前wrapper的真实高度
            const nextHeadStackInPageHeight = this.getNoIframeDomHeightInStack(index + 1, 0);
            if (
              (nextHeadStackInPageHeight ||
                (nextHeadStackInPage && nextHeadStackInPage.initDragHeight)) <= currentPageDistance
            ) {
              // 移动距离大于下一页头部题型高度
              // const heightAfterDel = moveDistance - nextHeadStackInPage.initDragHeight;
              const delStack =
                state.pageCell[index + 1].fillTopiclist &&
                state.pageCell[index + 1].fillTopiclist.shift();

              page.fillTopiclist[page.fillTopiclist.length - 1].isHurdle = false;
              // state.pageCell[index + 1].fillTopiclist[0].isHurdle = false;
              currentFootStackInPage &&
                (currentFootStackInPage.initDragHeight += delStack.initDragHeight);
              currentFootStackInPage &&
                (currentFootStackInPage.innerHTML += delStack.innerHTML || '');
              if (
                currentPageDistance - delStack.initDragHeight >=
                TH_HEIGHT + TAG_P_HEIGHT + PADDING_TOP_HEIGHT
              ) {
                const heightAfterDel = currentPageDistance - delStack.initDragHeight;
                const timer = setTimeout(() => {
                  let resolveTopic = {};
                  const nextPageHeadStack =
                    state.pageCell[index + 1] &&
                    state.pageCell[index + 1].fillTopiclist &&
                    state.pageCell[index + 1].fillTopiclist[0];
                  resolveTopic =
                    state.pageCell[index + 1] &&
                    state.pageCell[index + 1].fillTopiclist &&
                    state.pageCell[index + 1].fillTopiclist[0] &&
                    this.resolveTopicFactory(
                      index,
                      resolveTopic,
                      state.pageCell[index + 1].fillTopiclist[0],
                      heightAfterDel -
                        ((nextPageHeadStack || {}) && nextPageHeadStack.hasTitle ? TH_HEIGHT : 0), // 跨栏情况下如果是解答题的话 我们只需要减去一个底部的高度10px就可以 如果是其他题型目前有想到的是 作文题，英语作文题
                      true
                    );
                  if (resolveTopic && !resolveTopic.topHtml) {
                    // 这里有一种情况 就是下一页头部的题型中第一个元素的高度大于上一页拖拽的高度 也就是currentPageDistance
                    // 这里可以用resolveTopic.topHtml来判断 如果是空字符串则代表分解高度不足，不进行向上分解题型
                    // 则不应该push一个题型也就是不应该分解题型到上一页底部去
                  } else {
                    nextPageHeadStack &&
                      page.fillTopiclist.push({
                        ...state.pageCell[index + 1].fillTopiclist[0], //这个时候下标为0的元素应该是shift之后的
                        initDragHeight:
                          heightAfterDel - (nextPageHeadStack.hasTitle ? TH_HEIGHT : 0),
                        innerHTML: resolveTopic && resolveTopic.topHtml,
                        isHurdle: true,
                      });
                    state.pageCell[index + 1].fillTopiclist[0] &&
                      (state.pageCell[index + 1].fillTopiclist[0].initDragHeight -=
                        delStack.initDragHeight);
                    //   (state.pageCell[index + 1].fillTopiclist[0].initDragHeight -=
                    // delStack.initDragHeight);
                    state.pageCell[index + 1].fillTopiclist[0] &&
                      (state.pageCell[index + 1].fillTopiclist[0].innerHTML =
                        resolveTopic && resolveTopic.bottomHtml);
                    state.pageCell[index + 1].fillTopiclist[0] &&
                      (state.pageCell[index + 1].fillTopiclist[0].isSub = true);
                    state.pageCell[index + 1].fillTopiclist[0] &&
                      (state.pageCell[index + 1].fillTopiclist[0].hasTitle = false);
                  }

                  clearTimeout(timer);
                }, 70);
              }
              // if (heightAfterDel > TH_HEIGHT) {
              //   page.fillTopiclist.push({
              //     ...state.pageCell[index + 1].fillTopiclist[0],
              //     initDragHeight: heightAfterDel,
              //     isHurdle: true,
              //   });
              // }
            } else {
              // 移动距离小于下一页头部题型高度 如果下一页头部的高度小于最小高度则删除当前stack
              if (page.fillTopiclist[page.fillTopiclist.length - 1].type == 5) {
                // 处理语文作文 将currentPageDistance高度换算成WRITE_LINE_HEIGHT作文题行高的整数进行递归减法
              }
              let nextHeadStackInPage = nextPage && state.pageCell[index + 1].fillTopiclist[0];
              // const topicViewHeight = this.getTopicViewHeight(nextHeadStackInPage, index, 0);
              // if (nextHeadStackInPage && nextHeadStackInPage.initDragHeight < topicViewHeight) {
              //   nextHeadStackInPage.initDragHeight = topicViewHeight;
              //   return;
              // }
              resolveTopic &&
                page.fillTopiclist[page.fillTopiclist.length - 1] &&
                (page.fillTopiclist[page.fillTopiclist.length - 1].innerHTML +=
                  resolveTopic.topHtml || '');
              // 这里有一个bug 就是解答题默认的html都是空 所以通过上下头尾的 题号 no 小题号 xth来判断
              if (
                nextHeadStackInPage &&
                nextHeadStackInPage.no ==
                  (page.fillTopiclist[page.fillTopiclist.length - 1] &&
                    page.fillTopiclist[page.fillTopiclist.length - 1].no) &&
                nextHeadStackInPage.xth ==
                  (page.fillTopiclist[page.fillTopiclist.length - 1] &&
                    page.fillTopiclist[page.fillTopiclist.length - 1].xth)
              ) {
                resolveTopic &&
                  !resolveTopic.bottomHtml &&
                  page.fillTopiclist[page.fillTopiclist.length - 1] &&
                  (page.fillTopiclist[page.fillTopiclist.length - 1].isHurdle = true); // !resolveTopic.bottomHtml 这里只有向上拖拽分解的时候 bottom内容为空的时候 才算上下分解结束
              } else {
                resolveTopic &&
                  !resolveTopic.bottomHtml &&
                  page.fillTopiclist[page.fillTopiclist.length - 1] &&
                  (page.fillTopiclist[page.fillTopiclist.length - 1].isHurdle = false); // !resolveTopic.bottomHtml 这里只有向上拖拽分解的时候 bottom内容为空的时候 才算上下分解结束
              }
              resolveTopic &&
                page.fillTopiclist[page.fillTopiclist.length - 1] &&
                (page.fillTopiclist[
                  page.fillTopiclist.length - 1
                ].initDragHeight += currentPageDistance); // tu9ozhuai
              // currentPageDistance - TH_HEIGHT); // tu9ozhuai
              if (
                nextHeadStackInPage &&
                nextHeadStackInPage.type == 5 &&
                !resolveTopic.bottomHtml
              ) {
                // 如果下一个作文题留了一个空白小尾巴 直接删除小尾巴
                state.pageCell[index + 1].fillTopiclist &&
                  state.pageCell[index + 1].fillTopiclist.shift();
              } else {
                nextHeadStackInPage &&
                  (nextHeadStackInPage.innerHTML = resolveTopic
                    ? resolveTopic.bottomHtml || ''
                    : nextHeadStackInPage.innerHTML);
              }
              const domTotalHeight = this.minHeightWhenDragUp(index, 0); // 处理向上拖拽到最小dom高度不改变高度问题
              if (nextHeadStackInPage) {
                if (
                  nextHeadStackInPage.initDragHeight - currentPageDistance <=
                    domTotalHeight + MARGIN_BOTTOM + PADDING_TOP_HEIGHT &&
                  !resolveTopic.topHtml
                ) {
                  //  这种情况是为了处理拖拽当前页面最后题型的时候 如果拖拽的最小高度出发了 下一页头部的距离不变
                  resolveTopic &&
                    (nextHeadStackInPage.initDragHeight =
                      domTotalHeight + MARGIN_BOTTOM + PADDING_TOP_HEIGHT);
                } else {
                  resolveTopic && (nextHeadStackInPage.initDragHeight -= currentPageDistance);
                }
              }
              // nextHeadStackInPage && this.doWriteEnTopicWhiteSpace(nextHeadStackInPage, index, 0);
              // if (
              //   (nextHeadStackInPage && nextHeadStackInPage.initDragHeight) - currentPageDistance <
              //   TAG_P_HEIGHT
              // ) {
              //   // 如果下一页头部的高度小于最小高度则删除当前stack
              //   // const delStack = state.pageCell[index + 1].fillTopiclist.shift();
              //   // // page.fillTopiclist[page.fillTopiclist.length - 1] &&
              //   // //   (page.fillTopiclist[
              //   // //     page.fillTopiclist.length - 1
              //   // //   ].initDragHeight += moveDistance);
              //   // page.fillTopiclist[page.fillTopiclist.length - 1] &&
              //   //   (page.fillTopiclist[page.fillTopiclist.length - 1].innerHTML +=
              //   //     delStack.innerHTML);
              //   // page.fillTopiclist[page.fillTopiclist.length - 1] &&
              //   //   (page.fillTopiclist[page.fillTopiclist.length - 1].isHurdle = false);
              // }
            }

            // isSelfCall &&
            //   currentFootStackInPage &&
            //   (currentFootStackInPage.initDragHeight += isSelfCall
            //     ? moveDistance
            //     : currentPageDistance);
            // resolveTopic && (currentFootStackInPage.innerHTML += resolveTopic.bottomHtml);
            // resolveTopic &&
            //   nextHeadStackInPage &&
            //   (nextHeadStackInPage.innerHTML = resolveTopic.topHtml);
          } else {
            // debugger;
            // 当前页不是跨栏;
            if (
              nextHeadStackInPage.type == 2 &&
              currentPageDistance <= OBJECT_LINE_HEIGHT + TH_HEIGHT
            ) {
              // 客观题的情况下
              this.keepUpdateView = false;
              return;
            }
            if (
              currentPageDistance < TH_HEIGHT + PADDING_TOP_HEIGHT ||
              // currentPageDistance < TH_HEIGHT + TAG_P_HEIGHT + PADDING_TOP_HEIGHT ||
              (nextHeadStackInPage.type == 2 && currentPageDistance < TH_HEIGHT + TAG_110_HEIGHT)
            ) {
              // 如果上下页不跨栏 并且上一页的高度不足以填充一题的高度 则不做任何事情
              return;
            }
            resolveTopic =
              nextHeadStackInPage &&
              this.resolveTopicFactory(
                index,
                resolveTopic,
                nextHeadStackInPage,
                currentPageDistance -
                  (nextHeadStackInPage.hasTitle ? TH_HEIGHT : 0) -
                  PADDING_TOP_HEIGHT, // 这里向上拖拽需要减去题号高度 如果下一页头部有标题则需要减去头部高度 否则不需要
                // (isSelfCall ? currentPageDistance : moveDistance) - TH_HEIGHT, // 这里向上拖拽需要减去题号高度
                true
              );
            // console.log(
            //   'resolveTopic',
            //   isSelfCall,
            //   nextHeadStackInPage.type,
            //   nextHeadStackInPage,
            //   resolveTopic
            // );
            // page.fillTopiclist[page.fillTopiclist.length - 1].initDragHeight -= TH_HEIGHT;
            if (currentPageDistance >= nextHeadStackInPage.initDragHeight) {
              // 拖拽距离大于下一页头部题型的高度
              let nextHeadStackInPage = nextPage && state.pageCell[index + 1].fillTopiclist[0];
              page.fillTopiclist.push({ ...nextHeadStackInPage, isHurdle: false });
              // const heightAfterDrag = currentPageDistance - nextHeadStackInPage.initDragHeight;
              state.pageCell[index + 1].fillTopiclist.shift();
              const mytimer = setTimeout(() => {
                // 这里为什么要把dom更新后的的下一页头部高度减去拖拽高度 先注释
                // state.pageCell[index + 1].fillTopiclist[0] &&
                //   (state.pageCell[index + 1].fillTopiclist[0].initDragHeight -=
                //     currentPageDistance || 0);
                //   if(heightAfterDrag >=( state.pageCell[index + 1].fillTopiclist[0].hasTitle ? TH_HEIGHT: 0) +TAG_P_HEIGHT )
                //   clearTimeout(myTimer);
              }, 10);
            } else {
              if (!resolveTopic.topHtml) {
                // 这里有一种情况 就是下一页头部的题型中第一个元素的高度大于上一页拖拽的高度 也就是currentPageDistance
                // 这里可以用resolveTopic.topHtml来判断 如果是空字符串则代表分解高度不足，不进行向上分解题型
                // 则不应该push一个题型也就是不应该分解题型到上一页底部去
              } else {
                page.fillTopiclist.push({
                  ...nextHeadStackInPage,
                  innerHTML: resolveTopic && (resolveTopic.topHtml || ''),
                  // 如果下一个是有标题的 hasTitle为true的时候则需要减去头部高度
                  initDragHeight:
                    currentPageDistance - (nextHeadStackInPage.hasTitle ? TH_HEIGHT : 0),
                  // 为什么第一次拖拽就不需要真实dom的高度呢
                  // initDragHeight: currentPageDistance - TH_HEIGHT - PADDING_TOP_HEIGHT, // 为什么第一次拖拽就不需要真实dom的高度呢
                  // initDragHeight: (isSelfCall ? currentPageDistance : moveDistance) - TH_HEIGHT,
                  isHurdle: true,
                });
                // 这里要注意一种情况就是减少拖拽的高度之后剩余的高度不足题型的高度，则需要计算当前题型的真实dom高度

                nextHeadStackInPage.innerHTML = resolveTopic.bottomHtml || '';
                // nextHeadStackInPage.isHurdle = true;
                nextHeadStackInPage.hasTitle = false;
                nextHeadStackInPage.isSub = true;
                const timer = setTimeout(() => {
                  const domTotalHeight = this.minHeightWhenDragUp(index, 0); // 处理向上拖拽到最小dom高度不改变高度问题
                  nextHeadStackInPage.initDragHeight -=
                    // (isSelfCall ? currentPageDistance : moveDistance) - TH_HEIGHT;
                    currentPageDistance -
                    TH_HEIGHT * (nextHeadStackInPage.type != 3 ? 2 : 1) -
                    PADDING_TOP_HEIGHT; // 因为出了解答题分解题型没有头部高度 其他题型分解之后头部也有题号高度了
                  if (domTotalHeight >= nextHeadStackInPage.initDragHeight) {
                    nextHeadStackInPage.initDragHeight =
                      domTotalHeight + MARGIN_BOTTOM + PADDING_TOP_HEIGHT;
                  }
                  clearTimeout(timer);
                }, 10);
              }
            }
          }
          // console.log('下一页头部题型', resolveTopic, nextHeadStackInPage, currentFootStackInPage);
        }
        // if (index === state.pageCell.length - 1) {
        // 处理语文作文题最后一行破裂问题
        // const writeType = page.fillTopiclist[page.fillTopiclist.length - 1].type;
        // writeType == 5 ? writeType : page.fillTopiclist[0] && page.fillTopiclist[0].type;
        const myTimer = setTimeout(() => {
          page.fillTopiclist[0] && this.doWriteTopicWhiteSpace(page.fillTopiclist[0], index, 0);
          page.fillTopiclist[page.fillTopiclist.length - 1] &&
            this.doWriteTopicWhiteSpace(
              page.fillTopiclist[page.fillTopiclist.length - 1],
              index,
              page.fillTopiclist.length - 1
            );
          clearTimeout(myTimer);
        }, 80);
        // page.fillTopiclist[0] && this.doWriteEnTopicWhiteSpace(page.fillTopiclist[0], index, 0);
        page.fillTopiclist.forEach((topic, _topInx) => {
          topic && this.doWriteEnTopicWhiteSpace(page.fillTopiclist[_topInx], index, _topInx);
          // 为了遍历之后能将解答题的高度更新成真实的dom高度
        });
        // console.log(`当前第${index + 1}页看看currentPageDistance的值${currentPageDistance}`);
        // 不跨栏的情况下 向上拖拽下一页头部题型 整体分解上来的时候 英语作文提 高度会变为10px左右 为了修复这个bug加上这个方法
        // this.doWriteTopicWhiteSpace(page.fillTopiclist[0].type, index);

        // }
      } else {
        console.log('上面的布局保持不变', index);
      }
    });
    if (this.keepUpdateView && this.updateViewHeightCount <= state.pageCell.length) {
      // 满足两个条件终止递归
      const timer = setTimeout(() => {
        this.resolveFillTopicHtmlCount++; // 控制resolveFillTopicHtml方法执行次数
        this.updateViewHeightByDirectionUp(moveDistance, true);
        clearTimeout(timer);
      }, 100);
    } else {
      this.updateViewHeightCount = 0;
      this.resolveFillTopicHtmlCount = 0;
      this.hideLoading();
      // this.updateViewHeight(+moveDistance, undefined, true);
      return;
    }
  }

  overHeightByDirectionUp() {}

  showLoading() {
    // if (this.loadingInstance) {
    // } else {
    //   this.loadingInstance = Loading.service({
    //     fullscreen: true,
    //     text: '请稍后...',
    //     background: 'rgba(255,255,255,0)',
    //   });
    // }
    document.body.style.cursor = 'wait';
    document.querySelector('.card-make-content .card-make-box').style.pointerEvents = 'none';
    const timer = setTimeout(() => {
      // loading会阻碍用户操作所以 定时器强制清除
      // this.hideLoading();
      document.body.style.cursor = 'default';
      if (
        document.querySelector('.card-make-content .card-make-box') &&
        document.querySelector('.card-make-content .card-make-box').style.pointerEvents == 'none'
      ) {
        document.querySelector('.card-make-content .card-make-box').style.pointerEvents = 'auto';
      }
      clearInterval(timer);
    }, 3000);
  }
  hideLoading() {
    document.body.style.cursor = 'default';
    document.querySelector('.card-make-content .card-make-box').style.pointerEvents = 'auto';
  }

  /**
   *
   * @param {object} resolveTopic 分解上下html的对象
   * @param {object} nextStackInPage
   * @param {object} moveDistance
   * @param {object} isDragUp
   */
  resolveTopicFactory(index, resolveTopic, nextStackInPage, moveDistance, isDragUp) {
    resolveTopic =
      this.resolveFillTopicHtml(
        'drag',
        index,
        nextStackInPage.type,
        nextStackInPage,
        moveDistance,
        isDragUp
      ) || resolveTopic;
    resolveTopic =
      this.resolveWriteTopicHtml(
        nextStackInPage,
        nextStackInPage.innerHTML,
        moveDistance,
        isDragUp
      ) || resolveTopic;
    resolveTopic =
      this.resolveObjectTopicHtml(
        // 因为选择题 拖拽一小部分就会导致110px整体移动，所以下一页的stack height需要110的整数倍数加上
        nextStackInPage.type,
        nextStackInPage,
        moveDistance,
        isDragUp,
        index
      ) || resolveTopic;
    return resolveTopic;
  }

  /**
   * 拖拽最后元素切割
   * @param {*} page
   * @param {*} index
   * @param {*} overHeightAfterDelete
   */
  cutLastStackInPage(page, index, overHeightAfterDelete) {
    let lastStackInPage = page.fillTopiclist[page.fillTopiclist.length - 1]; // 当前纸张的最后一栈
    this.insertNextPageHeadStack(
      state.pageCell[index + 1],
      overHeightAfterDelete, // 多加10是为了编辑器回车超过高度的时候 去除滚动条
      page.fillTopiclist[page.fillTopiclist.length - 1].type,
      '',
      lastStackInPage
    );
    lastStackInPage && (lastStackInPage.initDragHeight -= overHeightAfterDelete + TH_HEIGHT);
    lastStackInPage && (lastStackInPage.isHurdle = true);
  }

  /**
   * 根据当前的stack题型是否跨栏 ishurde是否为true判断保存最后所需要的题型
   * @param {*} cachePage
   * @returns {undefined || Topic}
   */
  saveCacheStack(cachePage, cacheStacks, index) {
    const hasHurdle = cachePage.fillTopiclist.some(toptic => {
      return toptic.isHurdle; //遍历每个题型是否有跨栏属性 someHurdle=true 说明当前page是有跨栏
    });
    if (hasHurdle) {
      return;
    }
    cacheStacks[index] = cachePage.fillTopiclist[cachePage.fillTopiclist.length - 1];
  }

  /**
   * 复原题型，当拖拽高度大于剩余foot stack的高度
   *  客观题特殊对待（只要最后一行高度不足110px 则触发复原方法）
   */
  restoreTopticStack(index, restoredStack, page) {
    state.pageCell[index + 1].fillTopiclist[0] = restoredStack;
    page.fillTopiclist.pop();
  }

  /**
   * 填空题分解题型
   * @param {*} stack
   * @param {*} resolveHeight
   */
  resolveFillTopicHtml(action, index, type, stack, resolveHeight, isDragUp) {
    // if (this.resolveFillTopicHtmlCount >= 1) {
    //   // 控制这个方法在拖拽的时候只执行一次
    //   return;
    // }
    // resolveHeight = isDragUp ? resolveHeight : resolveHeight;
    // resolveHeight = isDragUp ? resolveHeight : resolveHeight + TAG_P_HEIGHT;
    const page = state.pageCell[index];
    let lastStackInPage = page.fillTopiclist[page.fillTopiclist.length - 1]; // 当前纸张的最后一栈
    //  加上TAG_P_HEIGHT 为了解答题回车键过多增加高度作为最后题型的时候分解题型多留空白
    if (type == 1 || type == 4 || type == 3 || type == 6) {
      //  1 表示填空题，2 表示客观题，3 表示解答题，4表示英文作文，5表示语文作文，6表示选做题
      if (!stack.innerHTML || stack.innerHTML.indexOf('<script type="text/javascript"') != -1) {
        return {
          topHtml: '',
          bottomHtml: '',
        };
      }
      // const space = stack.initDragHeight - ptags.length * TAG_P_HEIGHT - MARGIN_BOTTOM;
      // if (space > 0) { // 暂时不知道这行代码的意图
      //   return;
      // }
      try {
        let wrapperContentElements = document.querySelectorAll(WRAP_CONTENT_CLASS)[
          isDragUp ? index + 1 : index // 如果是向上拖拽则index需要+1 分解的是下一页头部题型
        ];
        const topicWrappers = wrapperContentElements.querySelectorAll(TOPIC_DB_CLASS);
        let _index = 0;
        if (isDragUp) {
          // 向上拖拽的话分解的就是当前页面题型列表的最后一个 否则就是第一个
          _index = 0;
        } else {
          _index = topicWrappers.length - 1;
          // _index = 0;
        }
        const iframe = topicWrappers[_index].getElementsByTagName('iframe')[0];
        // console.log('填空题分解题型真实nodes222', iframe, _index, topicWrappers, stack);
        const elements = iframe.contentWindow.document.body.childNodes;
        let realHeightAfterEdit = PADDING_TOP;
        let delIndex = 0;
        let cHeight = undefined;
        if (action == 'blur') {
          cHeight = resolveHeight;
          // cHeight = stack.initDragHeight;
        } else {
          cHeight = resolveHeight;
          // cHeight = isDragUp ? resolveHeight : stack.initDragHeight;
        }
        const ArrayFromElements = Array.from(elements);

        let topHtml = '';
        let bottomHtml = '';
        let bottomElements = [];
        let topElements = [];
        if (isDragUp) {
          let sapceWhiteHeight = 0;
          let domTotalHeight = 0;
          let lastPageDomTotalHeight = 0;
          const lastPageDoms = this.getIframeDomInStack(
            index,
            state.pageCell[index].fillTopiclist.length - 1
          );
          lastPageDoms &&
            lastPageDoms.length &&
            lastPageDoms.forEach(el => {
              lastPageDomTotalHeight += el.offsetHeight || 0;
            });
          if (lastStackInPage.isHurdle) {
            sapceWhiteHeight = lastStackInPage.initDragHeight - lastPageDomTotalHeight;
          }
          ArrayFromElements.forEach(el => {
            domTotalHeight += el.offsetHeight || 0;
          });
          sapceWhiteHeight > 0 && (resolveHeight = sapceWhiteHeight + resolveHeight);
          // 向上拖拽
          // 想一想 向上拖拽应该不处理空白高度
          let myheight = resolveHeight; // 减去
          ArrayFromElements.forEach((el, elIndex) => {
            // 这里分解iframe里面的dom 将高度遍历然后累加计算高度 如果超出高度小于累加的高度 大于之前dom的高度 则删除下标是累加高度的那个元素的下标
            realHeightAfterEdit += el.offsetHeight || 0;
            if (myheight > (el.offsetHeight + MARGIN_BOTTOM || 0)) {
              delIndex = elIndex + 1; // 所以应该是下标+1
            }
            myheight = myheight - el.offsetHeight;
            // console.log('向上拖拽', resolveHeight, cHeight, el.offsetHeight, realHeightAfterEdit);
          });
          topElements = ArrayFromElements.splice(0, delIndex);
          topElements = topElements.reverse();
          bottomElements = ArrayFromElements;
        } else {
          let spaceHeight = 0;
          let domTotalHeight = 0;
          ArrayFromElements.reverse().forEach(el => {
            domTotalHeight += el.offsetHeight || 0;
          });
          spaceHeight = stack.initDragHeight - domTotalHeight - PADDING_TOP; // 空白高度  // 向下拖拽  laststackPage 是用topHtml   nextstackPage  是用bottomHtml
          let myheight = cHeight - spaceHeight + MARGIN_BOTTOM * 4 + PADDING_TOP_HEIGHT; // 减去空白高度是否有超过元素的高度 +MARGIN_BOTTOM 是因为每个题型都是应该加上MARGIN_BOTTOM的
          ArrayFromElements.forEach((el, elIndex) => {
            // 这里分解iframe里面的dom 将高度遍历然后累加计算高度 如果超出高度小于累加的高度 大于之前dom的高度 则删除下标是累加高度的那个元素的下标
            realHeightAfterEdit += el.offsetHeight;
            if (myheight > realHeightAfterEdit) {
              // if (myheight > 0 && myheight < realHeightAfterEdit) {
              // 这种情况是超出高度空白高度小于一个元素的高度
              delIndex = elIndex + 1;
            }
            // myheight = myheight - realHeightAfterEdit;
          });
          if (cHeight - spaceHeight > 0 && delIndex == 0) {
            delIndex = 1;
          }
          bottomElements = ArrayFromElements.splice(0, delIndex).reverse();
          topElements = ArrayFromElements;
          resolveHeight = 0;
        }
        topElements.reverse().forEach(element => {
          if (element && element.outerHTML) {
            topHtml += element.outerHTML;
          }
        });
        bottomElements.forEach(element => {
          if (element && element.outerHTML) {
            bottomHtml += element.outerHTML;
            resolveHeight += element.offsetHeight;
          }
        });
        topHtml = appendKONGGEToSPAN(topHtml) || topHtml;
        bottomHtml = appendKONGGEToSPAN(bottomHtml) || bottomHtml;
        return {
          topHtml: topHtml || '',
          bottomHtml: bottomHtml || '',
          resolveHeight: resolveHeight,
        };
        // let ptags = stack.innerHTML.split('</p>');
        // ptags.pop();
        // ptags = ptags.map(ptag => {
        //   return ptag + '</p>';
        // });
        // const dragPTags =
        //   type == 4 ? parseInt(cHeight / TAG_P_HEIGHT) : Math.floor(cHeight / TAG_P_HEIGHT); // 拖拽高度四舍五入转换到p元素的个数
        // const hurdleTags = isDragUp ? ptags.splice(0, dragPTags) : ptags.splice(0, dragPTags);
        // // const hurdleTags = ptags.splice(0, dragPTags); // 数组反转然后切割跨栏的小题
        // // stack.innerHTML = result;
        // stack.isResolved = true; //设置当前分解stack题型是否是分解
        // console.log(
        //   'hahaha',
        //   isDragUp,
        //   resolveHeight,
        //   'topHtml',
        //   hurdleTags,
        //   'bottomHtml',
        //   ptags
        // );
        // 这里填空题向上拖拽tophtml一直是向上分解的部分
        // return {
        //   topHtml: hurdleTags.join(''),
        //   bottomHtml: ptags.join(''),
        //   resolveHeight: null,
        // };

        nextHeadStackTopic.innerHTML = hurdleTags.reverse().join('') + nextHeadStackTopic.innerHTML;
        nextHeadStackTopic.isResolved = true; //设置下一页分解stack题型是否是分解
        // this.setCurrentResolved(currentIndexInPages, true);
      } catch (e) {
        console.error('跨栏分解题目出错', e.message);
      }
    }
  }

  /**
   * 消除拖拽到语文作文题每次空白太多的情况 返回当前题型的真实高度
   * @param {*} type
   * @param {*} index
   */
  doWriteTopicWhiteSpace(stack, index, _index) {
    _index = _index || 0;
    if (stack && stack.type == 5) {
      //  1 表示填空题，2 表示客观题，3 表示解答题，4表示英文作文，5表示语文作文，6表示选做题
      // if (state.pageCell[index].fillTopiclist.length == 1) {
      const timer = setTimeout(() => {
        try {
          let wrapperContentElements = document.querySelectorAll(WRAP_CONTENT_CLASS)[index];
          const wrapper = wrapperContentElements.querySelectorAll(TOPIC_DB_CLASS);
          let writeLineNums =
            (wrapper[_index] && wrapper[_index].querySelectorAll(WRITE_TOPIC_LINE_CLASS).length) ||
            0;
          // let writeLineNums = wrapperContentElements.querySelectorAll(WRITE_TOPIC_LINE_CLASS)
          //   .length;
          stack.initDragHeight = writeLineNums * WRITE_LINE_HEIGHT + MARGIN_BOTTOM;
          clearTimeout(timer);
        } catch (e) {
          console.log('处理语文作文题空白太多报错', e.message);
          clearTimeout(timer);
        }
      }, 300);
      // }
    }
  }

  /**
   * 处理英语作文 填空题 高度遮挡下划线的问题 返回当前题型的真实高度
   * @param {*} type
   * @param {*} index
   */
  doWriteEnTopicWhiteSpace(stack, index, _index) {
    // if (stack && (stack.type == 4 || stack.type == 3 || stack.type == 1) && stack.innerHTML) {
    //   // 必须是跨栏情况才能做处理空白情况
    //   // if (state.pageCell[index].fillTopiclist.length == 1) {
    //   const timer = setTimeout(() => {
    //     let realHeightAfterEdit = 0;
    //     try {
    //       let wrapperContentElements = document.querySelectorAll(WRAP_CONTENT_CLASS)[index];
    //       // let stackItemNums = wrapperContentElements.querySelectorAll(WRITE_TOPIC_LINE_CLASS)
    //       //   .length;
    //       const topicWrappers = wrapperContentElements.querySelectorAll(TOPIC_DB_CLASS);
    //       const iframe = topicWrappers[_index].getElementsByTagName('iframe')[0];
    //       const elements = iframe.contentWindow.document.body.childNodes;
    //       Array.from(elements).forEach(el => {
    //         realHeightAfterEdit += el.offsetHeight;
    //       });
    //       const needComputedDomHeight =
    //         stack.initDragHeight - (realHeightAfterEdit + TAG_P_HEIGHT) < 0;
    //       if (needComputedDomHeight) {
    //         stack.initDragHeight = realHeightAfterEdit + MARGIN_BOTTOM + PADDING_TOP_HEIGHT;
    //         //加上TAG_P_HEIGHT 是因为高度够不上需要加上一个p的高度撑开
    //       }
    //       clearTimeout(timer);
    //     } catch (e) {
    //       console.log('处理英语作文题空白太多报错', e.message);
    //       clearTimeout(timer);
    //     }
    //   }, 300);
    //   // }
    // }
  }

  /**
   * 向上拖拽分解的题型达到最小高度时 不减少高度
   * @param pageCellIndex 当前页的下标
   */
  minHeightWhenDragUp(pageCellIndex, stackIndex) {
    const nextPageCell = state.pageCell[pageCellIndex + 1];
    let domTotalHeight = 0;
    if (nextPageCell) {
      const elements = this.getIframeDomInStack(pageCellIndex + 1, stackIndex);
      elements.forEach((el, elIndex) => {
        domTotalHeight += el.offsetHeight || 0;
      });
    }
    return domTotalHeight;
  }

  /**
   * 获取当前题型下iframe中的dom列表
   * @param {*} pageCellIndex 当前页的下标
   * @param {*} stackIndex 当前页的下标下题型的下标
   * @returns {Array<Element>} 返回当前题型下iframe中的dom列表
   */
  getIframeDomInStack(pageCellIndex, stackIndex) {
    const wrapperContentElements = document.querySelectorAll(WRAP_CONTENT_CLASS)[pageCellIndex];
    const topicWrappers =
      wrapperContentElements && wrapperContentElements.querySelectorAll(TOPIC_DB_CLASS);
    const iframe =
      topicWrappers &&
      topicWrappers[stackIndex].getElementsByTagName('iframe') &&
      topicWrappers[stackIndex].getElementsByTagName('iframe')[0];
    const elements = (iframe && iframe.contentWindow.document.body.childNodes) || [];
    return Array.from(elements);
  }
  /**
   * 获取不是ifame编辑器题型的wrapper高度
   * @param {*} pageCellIndex
   * @param {*} stackIndex
   */
  getNoIframeDomHeightInStack(pageCellIndex, stackIndex) {
    const wrapperContentElements = document.querySelectorAll(WRAP_CONTENT_CLASS)[pageCellIndex];
    const topicWrappers =
      wrapperContentElements && wrapperContentElements.querySelectorAll(TOPIC_DB_CLASS);
    return topicWrappers && topicWrappers[0] && (topicWrappers[0].offsetHeight || 0);
  }

  /**
    // 如果上拉距离很小 下一页头部的题型缩减的时候如果达到最小值(内容的可视区域 就是里面的p 大部分情况下是的) 则不做任何处理
   * 
   * @param {*} stack 
   * @param {*} index 
   * @param {*} _index 
   */
  getTopicViewHeight(stack, index, _index) {
    // let topicViewHeight = 0;
    // if (stack && stack.type == (1 || 3 || 4)) {
    //   try {
    //     let wrapperContentElements = document.querySelectorAll(WRAP_CONTENT_CLASS)[index + 1];
    //     const topicWrappers = wrapperContentElements.querySelectorAll(TOPIC_DB_CLASS);
    //     const iframe = topicWrappers[_index].getElementsByTagName('iframe')[0];
    //     let stackItemNums =
    //       iframe && iframe.contentWindow.document.getElementsByTagName('p').length;
    //     topicViewHeight = stackItemNums * TAG_P_HEIGHT + PADDING_TOP_HEIGHT + MARGIN_BOTTOM;
    //   } catch (e) {
    //     console.error('处理(内容的可视区域', e.message);
    //   }
    //   // }
    // }
    // return topicViewHeight;
  }

  resolveWriteTopicHtml(stack, innerHTML, resolveHeight, isDragUp, index) {
    // resolveHeight = resolveHeight - MARGIN_BOTTOM; // 语文作文题下方有一个10px左右的边距
    if (stack.type == 5) {
      try {
        if (index) {
          // 去除语文作文留白空间
          let wrapperContentElements = document.querySelectorAll(WRAP_CONTENT_CLASS)[index];
          const wrapper = wrapperContentElements.querySelectorAll(TOPIC_DB_CLASS);
          let writeLineNums =
            (wrapper[wrapper.length - 1] &&
              wrapper[wrapper.length - 1].querySelectorAll(WRITE_TOPIC_LINE_CLASS).length) ||
            0;
          const realHeight = writeLineNums * WRITE_LINE_HEIGHT;
          let whiteSpaceHeight = stack.initDragHeight - realHeight; // 语文作文题的留白空间
          // !isDragUp
          if (resolveHeight - whiteSpaceHeight) {
            resolveHeight = resolveHeight - whiteSpaceHeight;
          } else {
            resolveHeight = 0;
          }
        }
        let ptags = innerHTML.split('<div class="writing">');
        ptags.shift();
        ptags = ptags.map(ptag => {
          return '<div class="writing">' + ptag;
        });

        if (resolveHeight % WRITE_LINE_HEIGHT <= 5) {
          // resolveHeight = resolveHeight - WRITE_LINE_HEIGHT;
        }
        const dragPTags = isDragUp // 这里减去MARGIN_BOTTOM原因一样也是要留底的空白 怕整数 贴边
          ? parseInt(resolveHeight / WRITE_LINE_HEIGHT)
          : parseInt((resolveHeight - MARGIN_BOTTOM * 2) / WRITE_LINE_HEIGHT + 2); // 拖拽高度四舍五入转换到p元素的个数
        // 如果是向上拖拽的话 则截取的html是相反的
        const hurdleTags = isDragUp
          ? ptags.splice(0, dragPTags)
          : ptags.splice(ptags.length - dragPTags); //剩余的数组 数组反转然后切割跨栏的小题

        if (isDragUp) {
          return {
            topHtml: hurdleTags.join(''),
            bottomHtml: ptags.join(''),
            resolveHeight: null,
          };
        } else {
          return {
            topHtml: ptags.join(''),
            bottomHtml: hurdleTags.join(''),
            resolveHeight: dragPTags * WRITE_LINE_HEIGHT,
          };
        }
      } catch (e) {
        console.error('分解作文题报错', e.message);
      }
    }
  }

  /**
   *
   * @param {*} type
   * @param {*} lastStackInPage
   * @param {*} resolveHeight 拖拽超出的高度
   */
  resolveObjectTopicHtml(type, lastStackInPage, resolveHeight, isDragUp, index) {
    if (type == 2) {
      const OBJECT_HTML_PRE = '<div class="object-item">';
      try {
        let ptags = lastStackInPage.innerHTML.split(OBJECT_HTML_PRE);
        ptags.shift();
        ptags = ptags.map(ptag => {
          return OBJECT_HTML_PRE + ptag;
        });
        let dragPTags = 0;
        let maxResolveHeight = 0;
        // 这里不能定义客观题的高度为固定的110 因为存在高度不一样的客观题 所以循环rowHeightList去找下标
        // 这里有bug 存在上下页完全分页分离的情况下 通过rowHeightList 不好分解客观题
        if (isDragUp) {
          // if (lastStackInPage.isHurdle) {
          let maxResolveHeight = 0;
          lastStackInPage.rowHeightList &&
            lastStackInPage.rowHeightList.forEach((height, index) => {
              // height-10的原因是 计算不准确 -10之后高度是准确高度
              if (resolveHeight - MARGIN_BOTTOM > maxResolveHeight) {
                dragPTags = index;
                maxResolveHeight += height - 10;
              }
            });
          const delRowHeightList = lastStackInPage.rowHeightList.splice(0, dragPTags) || [];
          let prevPageStack =
            (state.pageCell[index] &&
              state.pageCell[index].fillTopiclist &&
              state.pageCell[index].fillTopiclist[
                state.pageCell[index].fillTopiclist.length - 1
              ]) ||
            {};
          prevPageStack.rowHeightList = (prevPageStack.rowHeightList || []).concat(
            delRowHeightList
          );
          // } else {
          //   dragPTags = parseInt((resolveHeight - MARGIN_BOTTOM) / OBJECT_LINE_HEIGHT);
          // }
        } else {
          lastStackInPage.rowHeightList &&
            lastStackInPage.rowHeightList.forEach((height, index) => {
              // height-10的原因是 计算不准确 -10之后高度是准确高度
              if (resolveHeight > maxResolveHeight) {
                dragPTags = index + 1;
                maxResolveHeight += height - 10;
              }
            });
          const delRowHeightList =
            lastStackInPage.rowHeightList.splice(
              lastStackInPage.rowHeightList.length - dragPTags
            ) || [];
          state.pageCell[index + 1] &&
            state.pageCell[index + 1].fillTopiclist &&
            (state.pageCell[index + 1].fillTopiclist[0].rowHeightList = delRowHeightList.concat(
              state.pageCell[index + 1].fillTopiclist[0].rowHeightList
            ));

          // dragPTags = Math.ceil(resolveHeight / OBJECT_LINE_HEIGHT);
        }
        let hurdleTags = [];
        let topHtml = null;
        if (isDragUp) {
          hurdleTags = ptags.splice(0, dragPTags);
          topHtml = hurdleTags.join('');
          return {
            topHtml: topHtml,
            bottomHtml: ptags.join(''),
            resolveHeight: maxResolveHeight || dragPTags * OBJECT_LINE_HEIGHT,
          };
        } else {
          hurdleTags = ptags.splice(ptags.length - dragPTags);
          if (ptags.length !== 0) {
            topHtml = ptags.join('');
          }
          return {
            topHtml: topHtml,
            bottomHtml: hurdleTags.join(''),
            resolveHeight: maxResolveHeight,
          };
        }
      } catch (e) {
        console.error('分解选择题出错', e.message);
      }
    }
  }

  addrResolveTopic(innerHTML, canFillHeight, currentTopicStack) {
    try {
      let ptags = innerHTML.split('</p>');
      ptags.pop();
      ptags = ptags.map(ptag => {
        return ptag + '</p>';
      });
      const dragPTags = Math.floor(canFillHeight / TAG_P_HEIGHT); // 拖拽高度四舍五入转换到p元素的个数
      const hurdleTags = ptags.splice(0, dragPTags); //剩余的数组 数组反转然后切割跨栏的小题
      // const result = ptags.join('');
      currentTopicStack.innerHTML = hurdleTags.join('');
      currentTopicStack.isResolved = true; //设置当前分解stack题型是否是分解
      return ptags.join('');
      // return result;
    } catch (e) {
      console.error('分解题型报错', e.message);
    }
  }

  /**
   * 作文题型分解
   * @param {*} innerHTML
   * @param {*} canFillHeight
   * @param {*} currentTopicStack
   */
  addrResolveWriteTopic(innerHTML, canFillHeight, currentTopicStack) {
    try {
      let ptags = innerHTML.split('<div class="writing">');
      ptags.shift();
      ptags = ptags.map(ptag => {
        return '<div class="writing">' + ptag;
      });
      const dragPTags = Math.floor(canFillHeight / WRITE_LINE_HEIGHT); // 拖拽高度四舍五入转换到p元素的个数
      const hurdleTags = ptags.splice(0, dragPTags); //剩余的数组 数组反转然后切割跨栏的小题
      // const result = ptags.join('');
      currentTopicStack.innerHTML = hurdleTags.join('');
      currentTopicStack.isResolved = true; //设置当前分解stack题型是否是分解
      return ptags.join('');
      // return result;
    } catch (e) {
      console.error('分解题型报错', e.message);
    }
  }

  /**
   * 开始跨栏分解题型计算p的高度
   * @param {*} overstepDistance 拖拽距离
   * @param {*} currentIndexInPages dragjs传过来的当前在纸张内的index下标
   */
  startResolveTopic(overstepDistance) {
    const CURRENTPAGE_FOOT_INDEX = this.findCurrentPageFootIndex(state.currentPageNum);
    const currentPageFootStack = this.findCurrentPageFootStack(
      state.currentPageNum,
      CURRENTPAGE_FOOT_INDEX
    );
    try {
      let ptags = currentPageFootStack.innerHTML.split('</p>');
      ptags.pop();
      ptags = ptags.map(ptag => {
        return ptag + '</p>';
      });
      const dragPTags = Math.ceil(overstepDistance / TAG_P_HEIGHT); // 拖拽高度四舍五入转换到p元素的个数
      const hurdleTags = ptags.reverse().splice(0, dragPTags); // 数组反转然后切割跨栏的小题
      const result = ptags.reverse().join('');
      currentPageFootStack.innerHTML = result;
      currentPageFootStack.isResolved = true; //设置当前分解stack题型是否是分解
      const nextHeadStackTopic = this.findNextPageHeadStack(
        state.currentPageNum + 1,
        NEXTPAGE_HEAD_INDEX
      ); // 新增跨栏数据到下一页头部
      nextHeadStackTopic.innerHTML = hurdleTags.reverse().join('') + nextHeadStackTopic.innerHTML;
      nextHeadStackTopic.isResolved = true; //设置下一页分解stack题型是否是分解
      // this.setCurrentResolved(currentIndexInPages, true);
    } catch (e) {
      console.error('跨栏分解题目出错', e.message);
    }
  }

  /**
   * 创建新的一页
   * @param {number} overstepDistance 超过当前页面最大高度的超出部分
   */
  createNextPage(overstepDistance) {
    const newPageCellData = {
      //  答题卡页面的布局
      layout: {
        // 三栏
        width:
          answerPanelState.answerSheet.acCardPanes == 3 ? PAGE_SIZE_CELL[1] : PAGE_SIZE_CELL[0],
        height: PAGE_CELL_HEIGHT,
        position: 'absolute',
        top: `${parseInt(PAGE_LAYOUT_TOP * state.pageCell.length) + 10}`,
        left: '50%',
        padding: '58px 44px',
        marginLeft: -353,
      },
      // 每种题型的内容高度（就是去除纸张上面考生信息的高度）
      contentHeight: PAGE_CELL_HEIGHT,
      // 填空题
      fillTopiclist: [],
      items: [],
    };
    store.commit('card/addPageCell', newPageCellData);
  }

  /**
   *  拖拽不是当前纸张最后一题并且没有达到拖拽没有达到可删除最少元素的高度
   *
   * @param {*} currentPageFootStack 当前纸张footpage 题型
   * @param {*} overstepDistance
   */
  cutOverDistanceWithNoFootStack(currentPageFootStack, overstepDistance) {
    // 这种情况下 当前纸张的最后foot stack题型的initDragHeight高度没更新 所以要寻找当前foot的dom元素去获取dom的offsetHeight
    const currentPageFootStackDomHeight = this.findCurrentFootStackDomHeight();

    currentPageFootStack.initDragHeight =
      currentPageFootStackDomHeight -
      TH_HEIGHT -
      BORDER_HEIGHT * 2 -
      MARGIN_BOTTOM -
      overstepDistance;
    currentPageFootStack.isHurdle
      ? null
      : this.insertNextPageHeadStack(state.pageCell[state.currentPageNum + 1], overstepDistance);
    const CURRENTPAGE_FOOT_INDEX = this.findCurrentPageFootIndex(state.currentPageNum);
    if (!currentPageFootStack.isHurdle) {
      this.setCurrentFootHurdle(state.currentPageNum, CURRENTPAGE_FOOT_INDEX, true);
    }
    // clearTimeout(timer);
  }

  /**
   * 拖拽的是当前纸张最后一栈（最后一个题型）
   * @param {*} target
   * @param {*} overstepDistance
   * @param {*} currentPageFootStack
   */
  cutOverDistanceWithFootStack(target, overstepDistance, currentPageFootStack, hasNextPage) {
    // const targetStyleHeight =
    //   target.offsetHeight - BORDER_HEIGHT * MARGIN_TOP_NUMS + MARGIN_BOTTOM - overstepDistance;
    // target.style.height = targetStyleHeight + 'px';
    // currentPageFootStack.initDragHeight = targetStyleHeight;
    // let timer = setTimeout(() => {
    // 定时器 因为store里面的数据不能及时更新 为了确保isHurdle的值是正确的
    // if (!hasNextPage) {
    currentPageFootStack.isHurdle
      ? null
      : this.insertNextPageHeadStack(state.pageCell[state.currentPageNum + 1], overstepDistance);
    // }
    const CURRENTPAGE_FOOT_INDEX = this.findCurrentPageFootIndex(state.currentPageNum);
    this.setCurrentFootHurdle(state.currentPageNum, CURRENTPAGE_FOOT_INDEX, true);
    // clearTimeout(timer);
    // }, 200);
  }

  /**
   * 判断当前拖拽超过距离超过当前元素下面的所有元素之和就删除下面的所有元素 增加在next page的头部stack题型当中去
   */
  cutOverDistanceMoreThanSumHeight(overstepDistance, currentIndexInPages, target) {
    const nextPageCell = state.pageCell[state.currentPageNum + 1]; // 下一页纸张的pageCell的数据
    let sumHeight = 0;
    let fillTopiclist = state.pageCell[state.currentPageNum].fillTopiclist;
    const reverseFillTopicList = JSON.parse(JSON.stringify(fillTopiclist)).reverse();
    try {
      reverseFillTopicList.forEach((reverseTopic, index) => {
        // 反转当前纸张的filltopicList数组然后遍历累加高度判断
        sumHeight += reverseTopic.initDragHeight + MARGIN_TOP;
        if (sumHeight > overstepDistance) {
          sumHeight -= reverseTopic.initDragHeight + MARGIN_TOP;
          throw new Error('myError');
        }
        // 如果当前拖拽元素下面的累加元素高度小于于拖拽超过部分 记录下标 删除下标元素
        const delStack = fillTopiclist.reverse().splice(index, 1); // delStack 删除的下标元素
        // 拖拽当前纸张是否有下一纸张
        const [delStackObj] = delStack;
        if (reverseTopic.isHurdle) {
          // 如果拖拽元素已经跨栏 那就把删除的元素拼接到下一页的头部元素（两个元素高度相加）
        } else {
          // 否则将delStack 删除的下标元素添加到下一页page的头部stack中

          this.addDelStackToNextPageHeadStack(nextPageCell, delStackObj);
        }
      });
    } catch (e) {
      if (e.message != 'myError') throw e;
    }
    fillTopiclist = fillTopiclist.reverse();
    const surplusHeightWithoutDelStack = overstepDistance - sumHeight; // 这个距离是拖拽距离减去删除的stack（题型）累加高度
    const CURRENTPAGE_FOOT_INDEX = this.findCurrentPageFootIndex(state.currentPageNum);
    if (surplusHeightWithoutDelStack > 0) {
      // state.pageCell[state.currentPageNum].fillTopiclist[currentIndexInPages].isHurdle = true;
      this.addsurplusStackToNextPageHeadStack(nextPageCell, surplusHeightWithoutDelStack); // 将overstepDistanceWithoutDelStack推入下一纸张的stack头部中并且isHurdle 跨栏
      this.setCurrentFootHurdle(state.currentPageNum, currentIndexInPages, true); // 塞入到下一纸张的头部同时设置当前拖拽的stack题型跨栏为true
    }

    target.style.height = target.offsetHeight - surplusHeightWithoutDelStack - MARGIN_BOTTOM + 'px';
    // fillTopiclist = fillTopiclist.reverse();
  }

  /**
   * 将剩余的的高度生成一个fillTopiclist放到下一页page头部stack中
   * @param {*} nextPageCell
   * @param {*} surplusHeightWithoutDelStack
   */
  addsurplusStackToNextPageHeadStack(nextPageCell, surplusHeightWithoutDelStack) {
    this.insertNextPageHeadStack(nextPageCell, surplusHeightWithoutDelStack);
  }

  /**
   * 将delStack 删除的下标元素添加到下一页page的头部stack中
   * @param {FillTopic} delStack fillTopiclist中的每一个item
   */
  addDelStackToNextPageHeadStack(nextPageCell, delStack) {
    nextPageCell.fillTopiclist.unshift(delStack);
  }

  /**
   * 通过 当前纸张下标寻找wrappercontent下面的topicbox数量
   * @param {number} currentPageNum  当前纸张的下标
   * @returns {number} 当前纸张的foot题型 下标
   */
  findCurrentPageFootIndex(currentPageNum) {
    try {
      const wrapperContentElements = document.querySelectorAll(WRAP_CONTENT_CLASS)[
        state.currentPageNum
      ]; // 鼠标旨在当前的纸张下标
      const topicBoxElements = wrapperContentElements.querySelectorAll(TOPIC_BOX_CLASS);
      return topicBoxElements.length - 1;
    } catch (e) {
      console.error('下标寻找wrappercontent下面的topicbox数量报错', e.message);
    }
  }

  /**
   *  单个页面的拖拽下标（如在页面二的下标1）层级相对于题型
   * @param {number} currentTargetIndex  当前所有target元素的下标
   * @returns {number} currentIndexInPages
   */
  findCurrentIndexInPages(currentTargetIndex) {
    // let currentIndexInPages = 0;
    // if (state.currentPageNum <= 0) {
    //   currentIndexInPages = currentTargetIndex;
    // } else {
    //   const prevAllPages = state.pageCell.slice(0, state.currentPageNum); // 当前纸张的上面所有纸张数据
    //   let prevAllPagesTopicNum = 0;
    //   prevAllPages.forEach(page => {
    //     prevAllPagesTopicNum += page.fillTopiclist.length;
    //   });
    //   currentIndexInPages = currentTargetIndex - prevAllPagesTopicNum;
    //   currentIndexInPages < 0 ? (currentIndexInPages = 0) : currentIndexInPages;
    // }

    return state.currentIndexInPage;
  }

  /**
   * 设置currentPageNum纸张foot最后一个题型的跨栏标志 isHurdle
   * @param {number} currentPageNum 当前纸张的下标
   * @param {number} footIndex 当前纸张最后一个题型的下标
   */
  setCurrentFootHurdle(currentPageNum, footIndex, isHurdle) {
    const currentPageCell = state.pageCell[currentPageNum]; // 下一页纸张的pageCell的数据
    const footStackTopic = currentPageCell.fillTopiclist[footIndex];
    footStackTopic && (footStackTopic.isHurdle = isHurdle);
  }

  /**
   * 设置当前分解stack题型是否是分解
   * @param {index} currentIndexInPages
   * @param {boolean} isResolved
   */
  setCurrentResolved(currentIndexInPages, isResolved) {
    const currentPageCell = state.pageCell[state.currentPageNum]; // 下一页纸张的pageCell的数据
    const currentStackTopic =
      currentPageCell.fillTopiclist[this.findCurrentIndexInPages(currentIndexInPages)];
    currentStackTopic.isResolved = isResolved;
  }

  /**
   * 查找当前纸张最后一个题型元素
   * @param {number} currentPageNum 当前纸张的下标
   * @param {number} footIndex 当前纸张最后一个题型的下标
   */
  findCurrentPageFootStack(currentPageNum, footIndex) {
    const currentPageCell = state.pageCell[currentPageNum]; // 当前纸张的pageCell的数据
    const footStackTopic = currentPageCell.fillTopiclist[footIndex];
    return footStackTopic;
  }

  /**
   * 这种情况下 当前纸张的最后foot stack题型的initDragHeight高度没更新 所以要寻找当前foot的dom元素去获取dom的offsetHeight
   *
   */
  findCurrentFootStackDomHeight() {
    return this.findCurrentFootStackDom().offsetHeight;
  }

  findCurrentFootStackDom() {
    const wrapperContentElements = document.querySelectorAll(WRAP_CONTENT_CLASS)[
      state.currentPageNum
    ]; // 鼠标旨在当前的纸张下标
    const topicBoxElements = wrapperContentElements.querySelectorAll(TOPIC_BOX_CLASS);
    return topicBoxElements[topicBoxElements.length - 1];
  }

  /**
   * 寻找当前纸张所在题型的dom元素
   * @param {number} currentIndexInPages
   */
  findCurrentPageStackDom(currentIndexInPages) {
    const wrapperContentElements = document.querySelectorAll(WRAP_CONTENT_CLASS)[
      state.currentPageNum
    ];
    const topicBoxElements = wrapperContentElements.querySelectorAll(TOPIC_BOX_CLASS);
    return topicBoxElements[currentIndexInPages];
  }

  /**
   * 查找下一纸张第一个题型元素
   * @param {number} nextPageNum 下一纸张的下标
   * @param {number} headIndex 下一纸张第一个题型的下标
   */
  findNextPageHeadStack(nextPageNum, headIndex, overstepDistance) {
    const nextPageCell = state.pageCell[nextPageNum]; // 下一页纸张的pageCell的数据
    if (nextPageCell) {
      const headStackTopic = nextPageCell.fillTopiclist[headIndex];
      return headStackTopic;
    } else {
      this.page.createNextPage(state.pageCell);
      // 下一页头部插入高度overstepDistance
      state.pageCell[state.pageCell.length - 1].fillTopiclist[0] = {
        initDragHeight: 'overstepDistance',
        innerHTML: '<p>下一页头部插入高度overstepDistance</p>',
        isHurdle: true,
      };
    }
  }
  /**
   * 寻找鼠标当前所在位置的下一页
   */
  findNextPage(overstepDistance, currentPageFootStack) {
    // let timer = setTimeout(() => {
    // 定时器 因为store里面的数据不能及时更新 为了确保isHurdle的值是正确的
    const CURRENTPAGE_FOOT_INDEX = this.findCurrentPageFootIndex(state.currentPageNum);
    if (currentPageFootStack && currentPageFootStack.isHurdle) {
      // 是否跨栏 isHurdle
      // 当前纸张最后元素是否跨栏 是则增加下一页纸  张头部的高度 否则新增跨栏到下一页头部
      const nextHeadStackTopic = this.findNextPageHeadStack(
        state.currentPageNum + 1,
        NEXTPAGE_HEAD_INDEX,
        overstepDistance
      );

      (
        nextHeadStackTopic || { ...nextHeadStackTopic, initDragHeight: 0 }
      ).initDragHeight += overstepDistance; // 累加新增下一页纸张头部的高度
    } else {
      this.setCurrentFootHurdle(state.currentPageNum, CURRENTPAGE_FOOT_INDEX, true);
      const nextPageCell = state.pageCell[state.currentPageNum + 1]; // 下一页纸张的pageCell的数据
      this.insertNextPageHeadStack(nextPageCell, overstepDistance);
    }
    // clearTimeout(timer);
    // }, 0);
  }

  /**
   * 在下一页的头栈插入多出的高度
   */
  insertNextPageHeadStack(
    nextPageCell,
    overstepDistance,
    type,
    innerHTML,
    beforeStack,
    resolveTopic
  ) {
    // nextPageCell.items.push({
    //   type: state.topticType || 1,
    // });
    if (type != 3) {
      nextPageCell.fillTopiclist.unshift({
        ...beforeStack,
        hasTitle: false,
        type: type,
        isSub: true, // 是否由拖拽生成的子题型stack
        isHurdle: true, //当前item是否属于跨栏内容
        isResolved: false, // 题型是否分解
        initDragHeight: overstepDistance,
        innerHTML: innerHTML || '',
      });
    } else {
      nextPageCell.fillTopiclist.unshift({
        ...beforeStack,
        hasTitle: resolveTopic && resolveTopic.topHtml == '' ? beforeStack.hasTitle : false,
        type: type,
        isSub: resolveTopic && resolveTopic.topHtml == '' ? false : true, // 是否由拖拽生成的子题型stack
        isHurdle: true, //当前item是否属于跨栏内容
        isResolved: false, // 题型是否分解
        initDragHeight: overstepDistance,
        innerHTML: innerHTML || '',
      });
    }
  }

  /**
   * 连接下一页头部stack 高度相加
   */
  connectNextPageHeadStack(nextPageCell, overstepDistance) {
    nextPageCell.fillTopiclist[0].initDragHeight += overstepDistance;
  }

  toString() {
    return 'toString' + ' myDrag' + this.myDrag + super.toString(); // 调用父类的toString()
  }
}
